<template>
  <div class="COMBAT_BASEINFOR">
    <div class="main_contain_border">
      <span class="home"></span>
      <span class="scoreArea">
        <span class="homeScore" v-text="2"></span>
        <span class="vs" v-text="'-'"></span>
        <span class="awayScore win" v-text="3"></span>
      </span>
      <span class="away"></span>
    </div>
  </div>
</template>

<script>
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'COMBAT_BASEINFOR',
  mixins: [cup_base_data_mixin],
  props: {
    datas: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.COMBAT_BASEINFOR {
  width: 100%;
  height: auto;
  .main_contain_border {
    width: 100%;
    height: 5.55vw;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    border: 1px solid var(--mixtmt_mainColor);
    .home,
    .away {
      position: relative;
      width: 38%;
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      flex-direction: column;
    }
    .home {
      align-items: flex-end;
    }
    .away {
      align-items: flex-start;
    }
    .scoreArea {
      width: 24%;
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      .homeScore,
      .awayScore,
      .vs {
        font-size: 2.083vw;
        font-weight: bold;
        color: var(--mixtmt_greyColor3);
      }
      .homeScore,
      .awayScore {
        width: calc(50% - 1.388vw);
        &.win {
          color: var(--mixtmt_subColor3_1);
        }
      }
      .homeScore {
        text-align: right;
      }
      .vs {
        width: 2.778vw;
        text-align: center;
      }
    }
  }
}
</style>
